import React from "react";
import Navbar from "components/Navbar";
import Footer from "components/Footer";
import { useLocation } from "react-router-dom";

type GrandLayoutType = {
  children: React.ReactNode;
};
const GrandLayout: React.FC<GrandLayoutType> = ({ children }) => {
  const location = useLocation();
  const shouldRenderNavbar =
    !location.pathname.includes("/login") &&
    !location.pathname.includes("/sign-up") &&
    !location.pathname.includes("/forgot-password") &&
    !location.pathname.includes("/dashboard") &&
    !location.pathname.includes("/projects") &&
    !location.pathname.includes("/offers") &&
    !location.pathname.includes("/profile") &&
    !location.pathname.includes("/projects-details") &&
    !location.pathname.includes("/visitor") &&
    !location.pathname.includes("/property-developers") &&
    !location.pathname.includes("/property-owners") &&
    !location.pathname.includes("/admin") &&
    !location.pathname.includes("/terms") &&
    !location.pathname.includes("/privacy");

  return (
    <div>
      {shouldRenderNavbar && <Navbar />}

      <div className={`${shouldRenderNavbar ? "mt-[80px]" : ""}  `}>
        {children}
      </div>
      {shouldRenderNavbar && <Footer />}
    </div>
  );
};

export default GrandLayout;
